import { Box, Stack, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { IClauseChecklistData } from "./ClauseChecklistsLegend";

interface IProps {
    item: IClauseChecklistData;
}

export const LegendItem = ({ item }: IProps) => {
    const theme = useTheme();
    const responsive = useMediaQuery(theme.breakpoints.down("lg"));
    const mobile = useMediaQuery(theme.breakpoints.down("md"));

    return (
        <Stack direction={"row"} spacing={2} alignItems={"center"}>
            <Box
                width={{ xs: 20, lg: 24 }}
                height={{ xs: 20, lg: 24 }}
                bgcolor={item.color}
                borderRadius={1}
                flexShrink={0}
            />

            <Typography
                variant={"subtitle1"}
                noWrap
                fontSize={mobile ? 12 : responsive ? 14 : 16}
            >
                {item.label}
            </Typography>
        </Stack>
    );
};
